import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7262364c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex flex-column shadow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "align-self-center" }, "Sobre el centro", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Centro de Lengua y Cultura Española Centro Picasso fue fundado en 2012. Desde sus inicios, uno de nuestros objetivos no solo ha sido enseñar español, sino también generar el interés de los estudiantes por el idioma a través de la inmersión total en la cultura española, lo que hace que las clases sean increíblemente emocionantes e interesantes y les ayuda a conocer todas las peculiaridades de la sociedad española. y Cultura. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Más info")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_b_card, {
      tag: "article",
      style: {"max-width":"35rem"},
      class: "mb-2 sobre__card-body",
      "border-variant": "white",
      align: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_b_button, {
          class: "sobre-button m-3",
          pill: ""
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}